<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="客户消费总览" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
            >
              <el-form-item>
                <month-picker @change="setTime"></month-picker>
              </el-form-item>

              <el-form-item label="PIN：">
                <el-input v-model.trim="form.customerPin"></el-input>
              </el-form-item>

              <el-form-item label="账号名：">
                <el-input v-model.trim="form.loginName"></el-input>
              </el-form-item>

              <el-form-item style="margin-left: 0px">
                <el-button type="primary" @click="query(query)">查询</el-button>
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList" class="jc-button-icon"
                  ><i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column label="PIN">
              <template slot-scope="scope">{{
                scope.row.pin | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="账号名">
              <template slot-scope="scope">{{
                scope.row.loginName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="客户名称">
              <template slot-scope="scope">{{
                scope.row.realName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="消费金额(元)">
              <template slot-scope="scope">{{
                scope.row.consumeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="现金支付(元)">
              <template slot-scope="scope">{{
                scope.row.cashPayFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="付费代金券(元)">
              <template slot-scope="scope">{{
                scope.row.payCouponFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                免费代金券(元)
                <el-tooltip
                  content="免费代金券不计入销售业绩"
                  placement="top-end"
                >
                  <i class="jc-icon-my-help"></i>
                </el-tooltip>
              </template>

              <template slot-scope="scope">{{
                scope.row.freeCouponFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="计入业绩金额(元)">
              <template slot-scope="scope">{{
                scope.row.achievmentCount | formatMoney
              }}</template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryMyCustomerAchievment,
  exportMyCustomerAchievment,
} from '@/api/distributor-api.js'
import { getDate } from '@/utils/index'
import routerMixins from '@/mixins/router-mixins.js'
import handlepageMixins from '@/mixins/handlepage-mixins.js'
import MonthPicker from '@/views/business/models/MonthPicker.vue'
export default {
  mixins: [routerMixins, handlepageMixins],
  data() {
    return {
      form: {
        pageSize: 10,
        pageIndex: 1,
        beginTime: getDate(new Date()).ym,
        endTime: getDate(new Date()).ym,
        customerPin: '',
      },
      total: 0,
      tableData: [],
      queryFunction: queryMyCustomerAchievment,
      exportFunction: exportMyCustomerAchievment,
    }
  },
  created() {
    this.query()
  },
  components: {
    MonthPicker,
  },
  methods: {
    setTime(time) {
      let { beginTime, endTime } = time
      this.form.beginTime = beginTime || ''
      this.form.endTime = endTime || ''
    },
  },
}
</script>
